module.exports = __webpack_public_path__ + "img/sprainedwrist_1.c7609b70.gif";